.root {
  align-items: center;
  border-radius: 100px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  gap: 6px;
  padding: 4px 10px;
  white-space: nowrap;
}

.root-variant-active {
  background: var(--color-success);
  color: var(--color-success-foreground);

  .dot {
    background: var(--color-success-dot);
  }
}

.root-variant-pending {
  background: var(--color-warning);
  color: var(--color-warning-foreground);

  .dot {
    background: var(--color-warning-dot);
  }
}

.root-variant-inactive {
  background: var(--color-secondary);
  color: var(--color-muted);

  .dot {
    background: var(--color-muted);
  }
}

.root-variant-error {
  background: var(--color-badge-error-bg);
  color: var(--color-badge-error-fg);

  .dot {
    background: var(--color-destructive);
  }
}

.root-variant-booked {
  background: var(--color-badge-info-bg);
  color: var(--color-badge-info-fg);

  .dot {
    background: var(--color-badge-info-dot);
  }
}

.root-variant-delivered {
  background: var(--color-badge-purple-bg);
  color: var(--color-badge-purple-fg);

  .dot {
    background: var(--color-badge-purple-dot);
  }
}

.root-variant-high {
  background: var(--color-badge-high-bg);
  color: var(--color-background);

  .dot {
    background: var(--color-destructive);
  }
}

.root-variant-medium {
  background: var(--color-badge-medium-bg);
  color: var(--color-background);

  .dot {
    background: var(--color-success-dot);
  }
}

.root-variant-low {
  background: var(--color-muted);
  color: var(--color-background);

  .dot {
    background: var(--color-secondary);
  }
}

.dot {
  border-radius: 50%;
  flex-shrink: 0;
  height: 6px;
  width: 6px;
}
